import React, { Component } from "react";
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBInput } from 'mdbreact';
import axios from 'axios';


class SubscribePage extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
        mail: '',
            
        
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit2 = this.handleFormSubmit2.bind(this);
        
    }

    handleChange(event) {
        let nam = event.target.name;
        let val = event.target.value;
        this.setState({ [nam]: val });
        console.log(val);

    
    
    }

    handleFormSubmit2(event) {
        event.preventDefault();

        axios.post("http://207.246.115.162:8080/api2", this.state)
        .then(alert("Thank you for subscribing!"))
        .then(this.setState({
        mail: '',
        
        }))
                .catch(function (error) {
                    if (error.response) {
                        alert("There was an error. Please try again.");
                    } })}

    



    render(){
    return (
       
            <MDBRow style={{margin:"0"}}>
                <MDBCol style={{width:"100%"}}>
                <form onSubmit={this.handleFormSubmit2}>
                        <br></br>
                        
                        <MDBInput
                            placeholder="Enter Your Email Address"
                            required
                            type="email"
                            value={this.state.mail}
                            name="mail"
                            onChange={this.handleChange}
                        />
                        
                        <div className="text-center mt-4">
                            <MDBBtn style={{color: "red"}} color="white" type="submit" className="join">Subscribe</MDBBtn>
                        </div>
                    </form>
                </MDBCol>
            </MDBRow>
        
    )}
}

export default SubscribePage;